<div style="padding: 20px 10px 0px 20px;">
  <h1 class="mat-display-1" style="margin-bottom: 20px;">Commerçants du marché {{market}}</h1>
</div>
<!-- <mat-card style="margin: 20px;">
    <mat-card-title>Marché {{market}}</mat-card-title>
    <mat-card-content>Afin de soutenir le tissu commerçant local pendant la crise sanitaire, le Pôle Relations Entreprises, Commerces et Carrières de la Ville a contacté plusieurs centaines d’enseignes depuis le début de la période de confinement pour établir un recensement des établissements ouverts. Les services municipaux sont à leur écoute pour les aider à traverser cette crise, tout en vous permettant de limiter vos déplacements.</mat-card-content>
  </mat-card> -->

<div *ngIf="market === 'Henri Barbusse'">
  <img style=" display: block; max-width: 95%; max-height: 600px; margin: auto;" src="assets/PLAN-MARCHE-PARVIS-v4-scaled.jpg" alt="" usemap="#image-map" (load)="resizePlanMapArea()" />

  <map name="image-map">
    <area alt="1" title="1" (click)="displayStandDialog('1')" coords="354,103,265,28" shape="rect">
    <area alt="2" title="2" (click)="displayStandDialog('2')" coords="368,921,477,1007" shape="rect">
    <area alt="3" title="3" (click)="displayStandDialog('3')" coords="819,932,905,1005" shape="rect">
    <area alt="4" title="4" (click)="displayStandDialog('4')" coords="56,996,134,1074" shape="rect">
    <area alt="5" title="5" (click)="displayStandDialog('5')" coords="894,28,1025,103" shape="rect">
    <area alt="6" title="6" (click)="displayStandDialog('6')" coords="961,932,1044,1005" shape="rect">
    <area alt="7" title="7" (click)="displayStandDialog('7')" coords="746,195,808,340" shape="rect">
    <area alt="8" title="8" (click)="displayStandDialog('8')" coords="446,100,621,28" shape="rect">
    <area alt="9" title="9" (click)="displayStandDialog('9')" coords="87,103,259,28" shape="rect">
    <area alt="10" title="10" (click)="displayStandDialog('10')" coords="955,1005,908,935" shape="rect">
    <area alt="11" title="11" (click)="displayStandDialog('11')" coords="1050,896,1114,971" shape="rect">
    <area alt="12" title="12" (click)="displayStandDialog('12')" coords="535,189,710,120" shape="rect">
    <area alt="13" title="13" (click)="displayStandDialog('13')" coords="482,1005,607,921" shape="rect">
    <area alt="14" title="14" (click)="displayStandDialog('14')" coords="785,963,724,785" shape="rect">
    <area alt="15" title="15" (click)="displayStandDialog('15')" coords="134,192,351,120" shape="rect">
    <area alt="16" title="16" (click)="displayStandDialog('16')" coords="1078,106,1278,31" shape="rect">
    <area alt="17" title="17" (click)="displayStandDialog('17')" coords="911,1113,1147,1044" shape="rect">
    <area alt="18" title="18" (click)="displayStandDialog('18')" coords="627,100,847,28" shape="rect">
    <area alt="19" title="19" (click)="displayStandDialog('19')" coords="1462,256,1398,409" shape="rect">
    <area alt="20" title="20" (click)="displayStandDialog('20')" coords="268,398,485,328" shape="rect">
    <area alt="21" title="21" (click)="displayStandDialog('21')" coords="975,156,1041,337" shape="rect">
    <area alt="22" title="22" (click)="displayStandDialog('22')" coords="1047,420,975,342" shape="rect">
    <area alt="23" title="23" (click)="displayStandDialog('23')" coords="688,1116,908,1044" shape="rect">
    <area alt="24" title="24" (click)="displayStandDialog('24')" coords="819,822,883,928" shape="rect">
    <area alt="25" title="25" (click)="displayStandDialog('25')" coords="1217,157,1108,372" shape="rect">
    <area alt="26" title="26" (click)="displayStandDialog('26')" coords="836,191,964,115" shape="rect">
    <area alt="27" title="27" (click)="displayStandDialog('27')" coords="477,1115,563,1042" shape="rect">
    <area alt="28" title="28" (click)="displayStandDialog('28')" coords="1094,374,1175,449" shape="rect">
    <area alt="29" title="29" (click)="displayStandDialog('29')" coords="1233,1120,1172,1042" shape="rect">
    <area alt="30" title="30" (click)="displayStandDialog('30')" coords="685,1117,568,1042" shape="rect">
    <area alt="31" title="31" (click)="displayStandDialog('31')" coords="1136,822,1203,742" shape="rect">
    <area alt="32" title="32" (click)="displayStandDialog('32')" coords="59,129,129,277" shape="rect">
    <area alt="33" title="33" (click)="displayStandDialog('33')" coords="1289,107,1417,26" shape="rect">
    <area alt="34" title="34" (click)="displayStandDialog('34')" coords="207,1115,382,1039" shape="rect">
  </map>
  <br />
</div>

<div style="display: flex; flex-wrap: wrap; justify-content: space-evenly; align-items: stretch;">
  <div class="stand-card" style="flex-grow: 1; margin: 10px; min-width: 310px; max-width: 340px;" *ngFor="let stand of stands$ | async; trackBy: trackByStandId">
    <mat-card style="min-width: 310px; max-width: 310px;">
      <mat-card-header>
        <mat-icon *ngIf="activities[stand.activity]" mat-card-avatar [ngStyle]="{ 'color': '#'+ (activities[stand.activity].color ? activities[stand.activity].color : '2E3D99') }" [svgIcon]="activities[stand.activity].iconName" style="height: 32px; width: 32px;"></mat-icon>
        <mat-card-title>{{stand.idPlan.length > 0 ? stand.idPlan + '. ' : ''}} {{stand.name.length > 0 ? stand.name : stand.contactName}}</mat-card-title>
        <mat-card-subtitle>{{stand.activity}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>

        {{stand.comment | nl2br }}

        <!-- <mat-divider></mat-divider> -->

        <mat-list dense>
          <mat-list-item *ngIf="stand.contactName">
            <mat-icon matListIcon style="color: #2E3D99">contacts</mat-icon>
            <h3 matLine>{{ stand.contactName }}</h3>
          </mat-list-item>
          <mat-list-item *ngIf="stand.phone">
            <mat-icon matListIcon style="color: #2E3D99">call</mat-icon>
            <h3 matLine><a href="tel:{{stand.phone}}">{{stand.phone}}</a></h3>
          </mat-list-item>
          <mat-list-item *ngIf="stand.email">
            <mat-icon matListIcon style="color: #2E3D99">email</mat-icon>
            <h3 matLine><a href="mailto:{{stand.email}}">{{stand.email}}</a></h3>
          </mat-list-item>
          <mat-list-item *ngIf="stand.website">
            <mat-icon matListIcon style="color: #2E3D99">language</mat-icon>
            <h3 matLine><a href="{{stand.website}}" target="_blank">{{ (stand.website.length > 60) ? (stand.website | slice:0:60)+'...' : stand.website}}</a></h3>
          </mat-list-item>

          <mat-list-item *ngIf="stand.delivery === true">
            <mat-icon matListIcon svgIcon="truck-fast-outline" style="color: #2E3D99"></mat-icon>
            <h3 matLine>Réalise des livraisons</h3>
          </mat-list-item>
          <mat-list-item *ngIf="stand.delivery === false">
            <mat-icon matListIcon svgIcon="truck" style="color: #2E3D99"></mat-icon>
            <h3 matLine>Ne réalise pas de livraisons</h3>
          </mat-list-item>
          <mat-list-item *ngIf="stand.delivery === true && stand.deliveryDays.length > 0">
            <mat-icon matListIcon svgIcon="calendar" style="color: #2E3D99"></mat-icon>
            <h3 matLine>Jours de livraison : {{ stand.deliveryDays }}</h3>
          </mat-list-item>

          <mat-list-item *ngIf="stand.orderByPhone === true">
            <mat-icon matListIcon svgIcon="phone-check" style="color: #2E3D99"></mat-icon>
            <h3 matLine>Prend les commandes par téléphone</h3>
          </mat-list-item>
          <mat-list-item *ngIf="stand.orderByEmail === true">
            <mat-icon matListIcon svgIcon="email-check" style="color: #2E3D99"></mat-icon>
            <h3 matLine>Prend les commandes par email</h3>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
</div>